<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" [mode]="sidenavMode" [opened]="sidenavOpened" fixedInViewport>
    <div class="sidenav-header">
      <mat-icon class="app-icon">local_shipping</mat-icon>
      <div class="app-title">
        <span class="title-main">Gate Pass</span>
        <span class="title-sub">Management System</span>
      </div>
    </div>
    <mat-divider></mat-divider>
    <mat-nav-list>
      <a mat-list-item *ngFor="let item of visibleNavItems"
         [routerLink]="item.route"
         routerLinkActive="active-link"
         (click)="isMobile && drawer.close()">
        <mat-icon matListItemIcon>{{item.icon}}</mat-icon>
        <span matListItemTitle>{{item.label}}</span>
      </a>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content>
    <mat-toolbar color="primary" class="app-toolbar">
      <button mat-icon-button (click)="toggleDrawer()" aria-label="Toggle menu">
        <mat-icon>menu</mat-icon>
      </button>
      <span class="toolbar-title" *ngIf="isMobile">Gate Pass</span>
      <span class="spacer"></span>
      <div class="user-section">
        <span class="user-name" *ngIf="!isMobile">{{userDisplayName}}</span>
        <button mat-icon-button [matMenuTriggerFor]="userMenu" aria-label="User menu">
          <div class="user-avatar">{{userInitials}}</div>
        </button>
      </div>
      <mat-menu #userMenu="matMenu">
        <div class="user-menu-header" mat-menu-item disabled>
          <strong>{{userDisplayName}}</strong>
          <small>{{currentUser?.roles?.join(', ')}}</small>
        </div>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="openChangePassword()">
          <mat-icon>lock_reset</mat-icon>
          <span>Change Password</span>
        </button>
        <button mat-menu-item (click)="logout()">
          <mat-icon>logout</mat-icon>
          <span>Logout</span>
        </button>
      </mat-menu>
    </mat-toolbar>

    <div class="content-area">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
